const KEY = "archijo-did";

const readCookie = () => {
  try {
    const m = document.cookie.match(/(?:^|; )archijo_did=([^;]+)/);
    return m ? m[1] : null;
  } catch {
    return null;
  }
};

// REQ-420: random device id kept in localStorage + cookie (both guarded).
export function deviceId() {
  let id = null;
  try {
    id = localStorage.getItem(KEY);
  } catch {}
  id = id || readCookie() || (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`);
  try {
    localStorage.setItem(KEY, id);
  } catch {}
  try {
    document.cookie = `archijo_did=${id}; path=/; max-age=${400 * 86400}; samesite=lax; secure`;
  } catch {}
  return id;
}
